import { CommonModule } from '@angular/common';
import { Component, Inject, inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import {
  UnknownCustomerModalComponent,
} from '@banyan/modules/register/components/unknown-customer-modal/unknown-customer-modal.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    RouterModule,
    TranslateModule,
  ],
})
export class ModalComponent {
  @Input() svgIcon: string = '';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() redirectUrl: string = '';
  @Input() closeButton: boolean = true;
  router = inject(Router);

  constructor(
    public dialogRef: MatDialogRef<UnknownCustomerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  closeModal(): void {
    this.dialogRef.close();
    if (this.redirectUrl != '') {
      this.router.navigate([this.redirectUrl]);
    }
  }
}
